import React from 'react';
import { FileSpreadsheet, X, Clock } from 'lucide-react';

/**
 * StagingImportTabs — Tab bar showing uploaded CSV lists.
 * "All Pending" tab + one tab per active import.
 */
export default function StagingImportTabs({ imports, activeImportId, onSelect, onDelete }) {
    return (
        <div className="flex items-center gap-1 border-b border-stone-200 px-1 overflow-x-auto">
            {/* All tab */}
            <button
                onClick={() => onSelect('')}
                className={`flex items-center gap-1.5 px-3 py-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                    !activeImportId
                        ? 'border-stone-900 text-stone-900'
                        : 'border-transparent text-stone-500 hover:text-stone-700 hover:border-stone-300'
                }`}
            >
                All Pending
                {imports.length > 0 && (
                    <span className="text-xs bg-stone-100 text-stone-600 rounded-full px-1.5 py-0.5">
                        {imports.reduce((sum, i) => sum + (i.pending_count || 0), 0)}
                    </span>
                )}
            </button>

            {/* Per-import tabs */}
            {imports.map(imp => (
                <button
                    key={imp.import_id}
                    onClick={() => onSelect(imp.import_id)}
                    className={`group flex items-center gap-1.5 px-3 py-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                        activeImportId === imp.import_id
                            ? 'border-stone-900 text-stone-900'
                            : 'border-transparent text-stone-500 hover:text-stone-700 hover:border-stone-300'
                    }`}
                >
                    <FileSpreadsheet className="w-3.5 h-3.5" />
                    <span className="max-w-[120px] truncate">{imp.list_name}</span>
                    <span className="text-xs bg-stone-100 text-stone-600 rounded-full px-1.5 py-0.5">
                        {imp.pending_count || 0}
                    </span>
                    {/* Delete tab */}
                    <span
                        onClick={(e) => { e.stopPropagation(); onDelete(imp.import_id); }}
                        className="opacity-0 group-hover:opacity-100 p-0.5 hover:bg-stone-200 rounded transition-all"
                        title="Discard this import"
                    >
                        <X className="w-3 h-3 text-stone-400 hover:text-red-500" />
                    </span>
                </button>
            ))}
        </div>
    );
}
